module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/birthday-edf7b2e48435d9e6bd768f39a943eac7.svg";